var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gallery-message" }, [
    _c(
      "div",
      { ref: "cardContainer", staticClass: "cards" },
      [
        _vm.currentIndex !== 0
          ? _c(
              "div",
              { staticClass: "prev", on: { click: _vm.prevCard } },
              [
                _c(
                  "md-button",
                  { staticClass: "md-icon-button" },
                  [_c("md-icon", [_vm._v("chevron_left")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.items, function (card, index) {
          return _c("GalleryImageCard", {
            key: "card-" + index,
            ref: "cardRefs",
            refInFor: true,
            attrs: {
              card: card,
              current: index === _vm.currentIndex,
              "block-id": _vm.data.blockId,
              "payload-id": _vm.data.id,
              "conversation-id": _vm.conversationId,
              "is-selected":
                _vm.$_.get(_vm.lastClickedButton, "cardId") === card.id,
              "selected-button-id": _vm.$_.get(
                _vm.lastClickedButton,
                "buttonId"
              ),
            },
          })
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "next" },
          [
            _vm.currentIndex !== _vm.items.length - 1
              ? _c(
                  "md-button",
                  {
                    staticClass: "md-icon-button",
                    on: { click: _vm.nextCard },
                  },
                  [_c("md-icon", [_vm._v("chevron_right")])],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }